import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { UnitSelect } from "../../Components/UnitSelect"
import { BlockField, BlockFieldInputs, BlockRow } from "../../Components/Block"
import { NumberInput } from "../../Components/Input"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipDataItem } from "../../Components/ShipDataItem"
import { IShipDataEngine } from "../../Types"
import { predefined } from "./Context"

interface ShipDataEngineViewProps {
  data: IShipDataEngine;
  editable: boolean;
  index: number;
  onEdited?: () => void;
}

export function ShipDataEngineView({ data, editable, index, onEdited }: ShipDataEngineViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `engines[${index}].`;

  { /* List for fuelTypes */ }
  // Initialize fuelType with the value from data, or undefined if not present
  const [fuelType, setFuelType] = useState<string | undefined>(data.fuelType);
  const predefinedTypes = predefined.fuelType;

  const selectFuelType = useCallback((value?: string) => {
    setFuelType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  { /* List for driveTypes */ }
  // Initialize driveType with the value from data, or undefined if not present
  const [driveType, setDriveType] = useState<string | undefined>(data.driveType);
  const predefinedDrives = predefined.engineDriveType;
  const selectDriveType = useCallback((value?: string) => {
    setDriveType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  return (
    <ShipDataItem namePrefix={namePrefix} id={data.id}>
      <BlockRow className="block-row-1 engine-fields-row">
        <BlockField label={t("engine#")} className="block_field_small_4">
          <NumberInput format="int" name={`${namePrefix}number`} defaultValue={data.number} onChange={onEdited} readOnly={true} />
        </BlockField>

        <BlockField label={t("engine_nmea_number")} className="block_field_small_4">
          <NumberInput format="int" name={`${namePrefix}nmeaNumber`} defaultValue={data.nmeaNumber} onChange={onEdited} readOnly={!editable} />
        </BlockField>

        <BlockField label={t("engine_short_name")} className="block_field_small_12">
          <input name={`${namePrefix}engineShortName`} defaultValue={data.engineShortName} onChange={onEdited} readOnly={!editable} maxLength={10} />
        </BlockField>

        <BlockField label={t("manufacturer")} className="block_field_small_20">
          <input name={`${namePrefix}manufacturer`} defaultValue={data.manufacturer} onChange={onEdited} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("model")}>
          <input name={`${namePrefix}model`} defaultValue={data.model} onChange={onEdited} readOnly={!editable} />
        </BlockField>
      </BlockRow>

      <BlockRow className="block-row-last engine-fields-row">
        <BlockField label={t("serial_number")} className="block_field_small_16">
          <input name={`${namePrefix}serialNumber`} defaultValue={data.serialNumber} onChange={onEdited} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("power")} className="block_field_small_8">
          <BlockFieldInputs>
            <NumberInput format="int" className="unit" name={`${namePrefix}power`} defaultValue={data.power} onChange={onEdited} readOnly={!editable} />
            <UnitSelect kind="power" name={`${namePrefix}powerUnit`} value={data.powerUnit} editable={editable} onChange={onEdited} />
          </BlockFieldInputs>
        </BlockField>
        <BlockField label={t("fuel_type")} className="block_field_small_10">
          <PredefinedSelect value={fuelType} predefined={predefinedTypes} label={(v) => t(`fuel_${v}`)} customValue={t("other")} name={`${namePrefix}fuelType`} onSelect={selectFuelType} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("drive_type")} className="block_field_small_10">
          <PredefinedSelect value={driveType} predefined={predefinedDrives} label={(v) => t(`engine_${v}`)} customValue={t("other")} name={`${namePrefix}driveType`} onSelect={selectDriveType} readOnly={!editable} />
        </BlockField>

        <BlockField label={t("propeller_type")} className="block_field_small_14">
          <input name={`${namePrefix}propellerType`} defaultValue={data.propellerType} onChange={onEdited} readOnly={!editable} />
        </BlockField>

      </BlockRow>
    </ShipDataItem>
  );
}
